import { Component } from '@angular/core';
import { PedidosServiceService } from './services/pedidos-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'SpoEstadps';
  enPreparacion:any = []
  Preparado:any = []
  mostrarVideo:boolean = false
  constructor(public pedidoService:PedidosServiceService){
    this.pedidoService.getPedidos(window.location.pathname).then( (x) => {
      this.enPreparacion = x.filter( (y: { estado: string; }) => y.estado == 'preparacion')
      this.Preparado = x.filter( (y: { estado: string; }) => y.estado == 'preparado')

    })
    setInterval(() => {
      this.obtenerPedidos()
    }, 30000);

  }
  obtenerPedidos(){
    this.pedidoService.getPedidos(window.location.pathname).then( (x) => {
      this.enPreparacion = x.filter( (y: { estado: string; }) => y.estado == 'preparacion')
      this.Preparado = x.filter( (y: { estado: string; }) => y.estado == 'preparado')

    })
  }
}
